import React from "react";
import { Chart as ChartJS,  CategoryScale,  LinearScale,  PointElement,  LineElement,  Title,  Tooltip,  Legend,} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register( CategoryScale,  LinearScale,  PointElement,  LineElement,  Title,  Tooltip,  Legend);


const AvtMultiBarChart = ({chartlabels,distanceitems,fuelitems,averageitems}) => {
  

 
  const data = {
  labels: chartlabels,
  datasets: [
    {
      label: "Distance Travelled",
      data: distanceitems,
       borderColor: "rgba(255, 99, 132, 1)",
      backgroundColor: "#f3d1d8",//"rgba(255, 99, 132, 0.2)",
      tension: 0.4,
    },
    {
      label: "Fuel Consumed",
      data: fuelitems,
      borderColor: "rgba(75, 192, 192, 1)",
      backgroundColor: "#d2f1f1",//"rgba(75, 192, 192, 0.2)",
      tension: 0.4,
    },
    {
      label: "Average in km/litre",
      data: averageitems,
      borderColor: "rgba(54, 162, 235, 1)",
      backgroundColor: "#cae2f3",//"rgba(54, 162, 235, 0.2)",
      tension: 0.4,
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "AVT MultiBar Chart",
    },
  },
};




 
  return (
    <div style={{ padding:"20px"}}>
      <Bar data={data} options={options} />

    
    </div>
  );
};

export default AvtMultiBarChart;

